module.exports = __webpack_public_path__ + "img/img6.ff330937.svg";